module.exports = "label,input{width:100%}#limitsComment{padding:8px}\n"